var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ai-tutor-close-button",class:{ 'no-transition': _vm.dragging },style:({
    transform: `translate3d(${_vm.x}px, ${_vm.y}px, 0)`
}),on:{"mousedown":function($event){$event.preventDefault();return _vm.onPointerDown.apply(null, arguments)},"touchstart":function($event){$event.preventDefault();return _vm.onPointerDown.apply(null, arguments)},"click":_vm.handleClick}},[_c('img',{staticClass:"ai-tutor-icon",attrs:{"src":_vm.iconSrc,"draggable":"false"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }